const blueStonePath = "/images/onefront/bluestone";

export const logoSrcMap = {
  ED: {
    default: {
      short: `${blueStonePath}/ED/prime_logo/ED-logo-prime.svg`,
      long: `${blueStonePath}/ED/prime_logo/ED-logo-prime-long.svg`,
    },
    negative: {
      short: `${blueStonePath}/ED/prime_logo/ED-logo-prime-negative-short.svg`,
      long: `${blueStonePath}/ED/prime_logo/ED-logo-prime-negative-long.svg`,
    },
  },
  OP: {
    default: {
      short: `${blueStonePath}/OP/prime_logo/OP-logo-prime.svg`,
      long: `${blueStonePath}/OP/prime_logo/OP-logo-prime-long.svg`,
    },
    negative: {
      short: `${blueStonePath}/OP/prime_logo/OP-logo-prime-negative-short.svg`,
      long: `${blueStonePath}/OP/prime_logo/OP-logo-prime-negative-long.svg`,
    },
    tiny: {
      tiny: `${blueStonePath}/OP/prime_logo/OP-logo-prime-white-short.svg`,
    },
  },
  GO: {
    default: {
      short: `${blueStonePath}/GV/prime_logo/GO-logo-prime.svg`,
      long: `${blueStonePath}/GV/prime_logo/GO-logo-prime-long.svg`,
    },
    negative: {
      short: `${blueStonePath}/GV/prime_logo/GO-logo-prime-negative-short.svg`,
      long: `${blueStonePath}/GV/prime_logo/GO-logo-prime-negative-long.svg`,
    },
  },
  TR: {
    default: {
      short: `${blueStonePath}/TL/prime_logo/TL-logo-prime-short.svg`,
      long: `${blueStonePath}/TL/prime_logo/TL-logo-prime-long.svg`,
    },
    negative: {
      short: `${blueStonePath}/TL/prime_logo/TL-logo-prime-negative-short.svg`,
      long: `${blueStonePath}/TL/prime_logo/TL-logo-prime-negative-long.svg`,
    },
  },
};
